
import React from 'react';
// import Navbar from '../../../Commonlibs/Navbar';
import PropertyListingPage from './PropertyListingPage';
import FindProperty from './FindProperty';


const PropertySearch = () => {
  return (
    <>
      {/* <Navbar /> */}
      {/* <FindProperty/> */}
      <PropertyListingPage/>
      
    </>
  );
};

export default PropertySearch;
